export const BGC_FIELDS = {
  compliance_list: 'compliance_list',
  frontier_zone: 'frontier_zone',
  negative_media: 'negative_media',
  pep: 'pep',
  process_data: 'process_data',
  restriction_data: 'restriction_data',
  family_relation_data: 'family_relation_data',
  company_data: 'company_data',
  credit_score_data: 'credit_score_data',
  financial_pendings_data: 'financial_pendings_data',
  risk_score: 'risk_score',
  financial_situation: 'financial_situation',
}

export const getBgcVariableTitle = (bgcVariable) => {
  const fields = {
    [BGC_FIELDS.compliance_list]: 'Compliance List',
    [BGC_FIELDS.frontier_zone]: 'Região de Risco',
    [BGC_FIELDS.negative_media]: 'Mídia Negativa',
    [BGC_FIELDS.pep]: 'PEP',
    [BGC_FIELDS.restriction_data]: 'Listas Restritivas',
    [BGC_FIELDS.process_data]: 'Processos Judiciais',
    [BGC_FIELDS.family_relation_data]: 'Vínculos Familiares',
    [BGC_FIELDS.company_data]: 'Participações Societárias e ESG',
    [BGC_FIELDS.financial_pendings_data]: 'Pendências financeiras',
    [BGC_FIELDS.credit_score_data]: 'Score de Crédito',
    [BGC_FIELDS.financial_situation]: 'Situação Financeira',
  }
  
  return fields[bgcVariable] || 'N/A'
}

export const DD_FIELDS = {
  XP_KINSHIP: "xp_kinship",
  PEP: "pep",
  NEGATIVE_MEDIA: "negative_media",
  RESTRICTION_DATA: "restriction_data",
  PROCESSES: "processes",
  REPRESENTATION_ACTIVITIES: "representation_activities",
  EXTERNAL_ACTIVITIES: "external_activities",
  PROFESSIONAL_ACTIVITIES: "professional_activities",
  ATTORNEY_ACTIVITIES: "attorney_activities",
  SOCIAL_NETWORK: "social_network",
}

export const SCORE_PARTICIPANTS = [
  'compliance_list',
  'negative_media',
  'restriction_data',
  'pep',
  'financial_pendings_data',
  'process_data',
  'frontier_zone',
  'company_data',
  'financial_situation', // credit_score_data + financial_pendings_data 
]
